import React from 'react'
import InternalComments from './InternalComments'
import GptComponent from './GptComponent'
import MovieAndOttNews from './movieAndOttNews'

const AccordionsContainer = props => {
  const {
    inputData,
    sendinputdata,
    sendBooleanValueChangeDone,
    movieMode,
    setIsLoading,
    movieData,
    editOttAndNewsPermission,
    DeleteOttAndNewsPermission,
    ApproveOttAndNewsPermission,
  } = props
  return (
    <>
      <InternalComments
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
      />
      <GptComponent inputData={inputData} setIsLoading={setIsLoading} />
      {movieMode !== 'create' && (
        <MovieAndOttNews
          inputData={inputData}
          sendinputdata={sendinputdata}
          editOttAndNewsPermission={editOttAndNewsPermission}
          DeleteOttAndNewsPermission={DeleteOttAndNewsPermission}
          ApproveOttAndNewsPermission={ApproveOttAndNewsPermission}
          movieData={movieData}
        />
      )}
    </>
  )
}

export default AccordionsContainer
